const SimulationCustomerGranteesExtraCompanyInformation = () => null;

export default SimulationCustomerGranteesExtraCompanyInformation;
